webpackJsonp([228497914701036],{

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,n){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (n), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){var n,t,e,i,r,o,s=a<0;if(a=Math.abs(a).toFixed(l.decimals),a+="",n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),(s?"-":"")+l.options.prefix+t+e+l.options.suffix}function s(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}function u(a){return"number"==typeof a&&!isNaN(a)}var l=this;if(l.version=function(){return"1.9.3"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:s,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),u(l.startVal)&&u(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!u(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.startAnimation = exports.formatNumber = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _countup = __webpack_require__(91);
	
	var _countup2 = _interopRequireDefault(_countup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Adapted from the countup.js format number function
	// https://github.com/inorganik/countUp.js/blob/master/countUp.js#L46-L60
	var formatNumber = exports.formatNumber = function formatNumber(start, options) {
	  var neg = start < 0;
	  var num = '' + Math.abs(start).toFixed(options.decimals);
	  var x = num.split('.');
	  var x1 = x[0];
	  var x2 = x.length > 1 ? '' + options.decimal + x[1] : '';
	  var rgx = /(\d+)(\d{3})/;
	
	  if (options.separator) {
	    while (rgx.test(x1)) {
	      x1 = x1.replace(rgx, '$1' + options.separator + '$2');
	    }
	  }
	
	  return '' + (neg ? '-' : '') + (options.prefix || '') + x1 + x2 + (options.suffix || '');
	};
	
	var startAnimation = exports.startAnimation = function startAnimation(component) {
	  if (!(component && component.spanElement)) {
	    throw new Error('You need to pass the CountUp component as an argument!\neg. this.myCountUp.startAnimation(this.myCountUp);');
	  }
	
	  var _component$props = component.props,
	      decimal = _component$props.decimal,
	      decimals = _component$props.decimals,
	      duration = _component$props.duration,
	      easingFn = _component$props.easingFn,
	      end = _component$props.end,
	      formattingFn = _component$props.formattingFn,
	      onComplete = _component$props.onComplete,
	      onStart = _component$props.onStart,
	      prefix = _component$props.prefix,
	      separator = _component$props.separator,
	      start = _component$props.start,
	      suffix = _component$props.suffix,
	      useEasing = _component$props.useEasing;
	
	
	  var countupInstance = new _countup2.default(component.spanElement, start, end, decimals, duration, {
	    decimal: decimal,
	    easingFn: easingFn,
	    formattingFn: formattingFn,
	    separator: separator,
	    prefix: prefix,
	    suffix: suffix,
	    useEasing: useEasing,
	    useGrouping: !!separator
	  });
	
	  if (typeof onStart === 'function') {
	    onStart();
	  }
	
	  countupInstance.start(onComplete);
	};
	
	var CountUp = function (_React$Component) {
	  _inherits(CountUp, _React$Component);
	
	  function CountUp() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CountUp);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call.apply(_ref, [this].concat(args))), _this), _this.spanElement = null, _this.refSpan = function (span) {
	      _this.spanElement = span;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CountUp, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      startAnimation(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var hasCertainPropsChanged = this.props.duration !== nextProps.duration || this.props.end !== nextProps.end || this.props.start !== nextProps.start;
	
	      return nextProps.redraw || hasCertainPropsChanged;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      startAnimation(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          start = _props.start,
	          decimal = _props.decimal,
	          decimals = _props.decimals,
	          separator = _props.separator,
	          prefix = _props.prefix,
	          suffix = _props.suffix,
	          style = _props.style,
	          formattingFn = _props.formattingFn;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: className, ref: this.refSpan, style: style },
	        typeof formattingFn === 'function' ? formattingFn(start) : formatNumber(start, {
	          decimal: decimal,
	          decimals: decimals,
	          separator: separator,
	          prefix: prefix,
	          suffix: suffix
	        })
	      );
	    }
	  }]);
	
	  return CountUp;
	}(_react2.default.Component);
	
	CountUp.defaultProps = {
	  className: undefined,
	  decimal: '.',
	  decimals: 0,
	  duration: 3,
	  easingFn: null,
	  end: 100,
	  formattingFn: null,
	  onComplete: undefined,
	  onStart: undefined,
	  prefix: '',
	  separator: '',
	  start: 0,
	  suffix: '',
	  redraw: false,
	  style: undefined,
	  useEasing: true
	};
	exports.default = CountUp;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(173);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(174);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(50);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters or exits.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ```js
	 * import CSSTransition from 'react-transition-group/CSSTransition';
	 *
	 * const Fade = ({ children, ...props }) => (
	 *  <CSSTransition
	 *    {...props}
	 *    timeout={500}
	 *    classNames="fade"
	 *  >
	 *   {children}
	 *  </CSSTransition>
	 * );
	 *
	 * class FadeInAndOut extends React.Component {
	 *   constructor(...args) {
	 *     super(...args);
	 *     this.state= { show: false }
	 *
	 *     setInterval(() => {
	 *       this.setState({ show: !this.state.show })
	 *     }, 5000)
	 *   }
	 *   render() {
	 *     return (
	 *       <Fade in={this.state.show}>
	 *         <div>Hello world</div>
	 *       </Fade>
	 *     )
	 *   }
	 * }
	 * ```
	 *
	 * And the coorresponding CSS for the `<Fade>` component:
	 *
	 * ```css
	 * .fade-enter {
	 *   opacity: 0.01;
	 * }
	 *
	 * .fade-enter.fade-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 500ms ease-in;
	 * }
	 *
	 * .fade-exit {
	 *   opacity: 1;
	 * }
	 *
	 * .fade-exit.fade-exit-active {
	 *   opacity: 0.01;
	 *   transition: opacity 300ms ease-in;
	 * }
	 * ```
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      return { className: className, activeClassName: activeClassName };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransition = __webpack_require__(98);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _TransitionGroup = __webpack_require__(99);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Transition = __webpack_require__(50);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition2.default,
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransition: _CSSTransition2.default
	};

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 15px 0 !important;\n  span.timer {\n    font-size: 60px !important;\n  }\n"], ["\n  padding: 15px 0 !important;\n  span.timer {\n    font-size: 60px !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: #fff;\n  padding: 20px;\n  border-radius: 4px;\n  text-align: center;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  margin: 0 10px;\n"], ["\n  background: #fff;\n  padding: 20px;\n  border-radius: 4px;\n  text-align: center;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  margin: 0 10px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  margin-top: -20px;\n  padding-bottom: 70px;\n"], ["\n  margin-top: -20px;\n  padding-bottom: 70px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100% !important;\n"], ["\n  width: 100% !important;\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_countup_1 = __webpack_require__(68);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(8);
	var AchievementsCounterBlockElement = function AchievementsCounterBlockElement(props) {
	    var iconString = props.iconString,
	        counterStart = props.counterStart,
	        counterEnd = props.counterEnd,
	        counterDuration = props.counterDuration,
	        counterText = props.counterText,
	        counterReady = props.counterReady;
	
	    return React.createElement(CounterWrapper, { className: "col-sm-6 col-md-6 col-lg-4" }, React.createElement(ShadowEffectWrapper, null, React.createElement("i", { className: "material-icons brand-color", style: { fontSize: '50px' } }, iconString), React.createElement("span", { className: "timer" }, counterReady ? React.createElement(react_countup_1.default, { start: counterStart, end: counterEnd, duration: counterDuration }) : React.createElement("span", null, counterEnd)), React.createElement("span", { className: "count-description" }, counterText)));
	};
	/** STYLES => AchievementsCounterBlockElement */
	var CounterWrapper = styled_components_1.default.div(_templateObject);
	var ShadowEffectWrapper = styled_components_1.default.div(_templateObject2);
	
	var AchievementsCounterBlock = function (_React$Component) {
	    _inherits(AchievementsCounterBlock, _React$Component);
	
	    function AchievementsCounterBlock(props) {
	        _classCallCheck(this, AchievementsCounterBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            countersReady: false
	        };
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        return _this;
	    }
	
	    AchievementsCounterBlock.prototype.onComponentView = function onComponentView() {
	        // ODLICZNIKI
	        this.setState({ countersReady: true });
	        // GOOGLE EVENT
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    AchievementsCounterBlock.prototype.render = function render() {
	        var counters = this.props.counters;
	        var countersReady = this.state.countersReady;
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(AchievementsCounterBlockWrapper, { className: "facts-two" }, React.createElement(AchievementsCounterContainerWrapper, { className: "container" }, React.createElement("div", { className: "row text-center" }, counters.map(function (counter, index) {
	            return React.createElement(AchievementsCounterBlockElement, _extends({ key: index }, counter, { counterReady: countersReady }));
	        })))));
	    };
	
	    return AchievementsCounterBlock;
	}(React.Component);
	/** STYLES => AchievementsCounterBlock */
	
	
	var AchievementsCounterBlockWrapper = styled_components_1.default.section(_templateObject3);
	var AchievementsCounterContainerWrapper = styled_components_1.default.div(_templateObject4);
	exports.default = AchievementsCounterBlock;

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_transition_group_1 = __webpack_require__(100);
	var FadingElement = function FadingElement(props) {
	    return React.createElement(react_transition_group_1.Transition, { in: props.in, timeout: 150 }, function (state) {
	        return React.createElement("div", { style: _extends({}, DefaultStyle, TransitionStyles[state]) }, props.children);
	    });
	};
	/** STYLES */
	var DefaultStyle = {
	    transition: "opacity .15s linear",
	    opacity: 0,
	    display: 'none'
	};
	var TransitionStyles = {
	    entering: {
	        opacity: 0,
	        display: 'none'
	    },
	    entered: {
	        opacity: 1,
	        display: 'block'
	    }
	};
	exports.default = FadingElement;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  .active:after {\n    border-top-color: #03a9f4 !important;\n  }\n"], ["\n  .active:after {\n    border-top-color: #03a9f4 !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  @media (min-width : 993px) {\n    height: 330px;\n  }\n  @media (max-width : 800px) {\n    height: 380px;\n  }\n  @media (max-width : 600px) {\n    height: 450px;\n  }\n  @media (max-width : 550px) {\n    height: 500px;\n  }\n  @media (max-width : 550px) {\n    height: 600px;\n  }\n"], ["\n  @media (min-width : 993px) {\n    height: 330px;\n  }\n  @media (max-width : 800px) {\n    height: 380px;\n  }\n  @media (max-width : 600px) {\n    height: 450px;\n  }\n  @media (max-width : 550px) {\n    height: 500px;\n  }\n  @media (max-width : 550px) {\n    height: 600px;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', sans-serif !important;\n  font-size: 20px !important;\n  min-width: 0 !important;\n  border-radius: 15% !important;\n  padding-top: 0px !important;\n  &[data-tab-is-active~=\"true\"] {\n    color: #03a9f4 !important;\n  }  \n  &[data-tab-is-active~=\"false\"] {\n    background: #03a9f4 !important;\n    color: white;\n  }\n  float: none !important;\n"], ["\n  font-family: 'Roboto', sans-serif !important;\n  font-size: 20px !important;\n  min-width: 0 !important;\n  border-radius: 15% !important;\n  padding-top: 0px !important;\n  &[data-tab-is-active~=\"true\"] {\n    color: #03a9f4 !important;\n  }  \n  &[data-tab-is-active~=\"false\"] {\n    background: #03a9f4 !important;\n    color: white;\n  }\n  float: none !important;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-weight: bold !important;\n  :hover {\n    background: #03a9f4 !important;\n    span {\n      background: white !important;\n      color: #03a9f4 !important;\n    }\n  }\n  &[data-tab-is-active~=\"true\"] {\n    background: #03a9f4 !important;\n  }\n"], ["\n  font-weight: bold !important;\n  :hover {\n    background: #03a9f4 !important;\n    span {\n      background: white !important;\n      color: #03a9f4 !important;\n    }\n  }\n  &[data-tab-is-active~=\"true\"] {\n    background: #03a9f4 !important;\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var fading_element_1 = __webpack_require__(58);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(8);
	var IntroStepSelectBlockElementSelector = function IntroStepSelectBlockElementSelector(props) {
	  var activeElementOrdinal = props.activeElementOrdinal,
	      elementOrdinal = props.elementOrdinal,
	      selectElement = props.selectElement,
	      elementSelectorTitle = props.elementSelectorTitle;
	
	  var elementIsActive = activeElementOrdinal == elementOrdinal;
	  return React.createElement("li", { className: elementIsActive ? "active" : "", onClick: function onClick() {
	      return selectElement(elementOrdinal);
	    } }, React.createElement(StyledLink, { "data-tab-is-active": elementIsActive }, React.createElement(StyledSpan, { className: "badge", "data-tab-is-active": elementIsActive }, elementOrdinal), elementSelectorTitle));
	};
	
	var IntroStepSelectBlock = function (_React$Component) {
	  _inherits(IntroStepSelectBlock, _React$Component);
	
	  function IntroStepSelectBlock(props) {
	    _classCallCheck(this, IntroStepSelectBlock);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeTabIndex: 1
	    };
	    _this.onComponentView = _this.onComponentView.bind(_this);
	    _this.onElementSelect = _this.onElementSelect.bind(_this);
	    return _this;
	  }
	
	  IntroStepSelectBlock.prototype.onComponentView = function onComponentView() {
	    if (this.props.componentViewEventType) {
	      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	    }
	  };
	
	  IntroStepSelectBlock.prototype.onElementSelect = function onElementSelect(elementOrdinal) {
	    // SELECTING ELEMENT
	    this.setState({ activeTabIndex: elementOrdinal });
	    // GOOGLE EVENT
	    if (this.props.elementSelectEventType) {
	      googleAnalyticsService.trackEvent(this.props.elementSelectEventType);
	    }
	  };
	
	  IntroStepSelectBlock.prototype.renderElementDescription = function renderElementDescription(elementDescription) {
	    // SPRAWDZANIE CZY ELEMENT DESCRIPTION JEST LISTĄ
	    var elementDescriptionIsArray = Array.isArray(elementDescription);
	    // ZWRACANIE DANYCH
	    return React.createElement("div", null, !elementDescriptionIsArray && React.createElement("p", null, elementDescription), elementDescriptionIsArray && elementDescription.map(function (elementDescriptionPart, i) {
	      return React.createElement("p", { key: i }, elementDescriptionPart);
	    }));
	  };
	
	  IntroStepSelectBlock.prototype.render = function render() {
	    var _this2 = this;
	
	    var stepSelectElements = this.props.stepSelectElements;
	    var activeTabIndex = this.state.activeTabIndex;
	
	    return React.createElement("div", { className: "goodgrowth-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(IntroStepSelectBlockWrapper, { className: "content" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-sm-12" }, React.createElement("div", { className: "tabbable bigtabs tabs-top-horizontal" }, React.createElement("ul", { className: "nav nav-tabs" }, stepSelectElements.map(function (element, index) {
	      return React.createElement(IntroStepSelectBlockElementSelector, _extends({ key: index, activeElementOrdinal: activeTabIndex, elementOrdinal: index + 1, selectElement: _this2.onElementSelect }, element));
	    })), React.createElement(FadingElementTabContentWrapper, { className: "tab-content", style: { borderTop: "1px solid #03a9f4" } }, stepSelectElements.map(function (element, index) {
	      return React.createElement(fading_element_1.default, { in: activeTabIndex == index + 1, key: index }, React.createElement("div", { className: activeTabIndex == index + 1 ? "tab-pane fade active in" : "tab-pane fade" }, React.createElement("h4", null, element.elementSelectorTitle), _this2.renderElementDescription(element.elementSelectorDescription)));
	    })))))));
	  };
	
	  return IntroStepSelectBlock;
	}(React.Component);
	/** STYLES */
	
	
	var IntroStepSelectBlockWrapper = styled_components_1.default.section(_templateObject);
	var FadingElementTabContentWrapper = styled_components_1.default.div(_templateObject2);
	var StyledSpan = styled_components_1.default.span(_templateObject3);
	var StyledLink = styled_components_1.default.a(_templateObject4);
	exports.default = IntroStepSelectBlock;

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 270px;\n  p {\n    text-transform: initial !important;\n  }\n  span.tooltip-text {\n    border-bottom: 1px dotted;\n    text-transform: initial !important;\n  }\n  span {\n    float: right;\n    text-align: left;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n  }\n  span:before {\n    left: 50% !important;\n    margin-left: -10px;\n  }\n  span.tooltip-content {\n    text-transform: initial !important;\n  }\n  a {\n    color: #fff !important;\n    display: block !important;\n    border-bottom: none !important;\n    opacity: 1 !important;\n  }\n  a:visited {\n    color: #fff !important;\n  }\n"], ["\n  max-width: 270px;\n  p {\n    text-transform: initial !important;\n  }\n  span.tooltip-text {\n    border-bottom: 1px dotted;\n    text-transform: initial !important;\n  }\n  span {\n    float: right;\n    text-align: left;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n  }\n  span:before {\n    left: 50% !important;\n    margin-left: -10px;\n  }\n  span.tooltip-content {\n    text-transform: initial !important;\n  }\n  a {\n    color: #fff !important;\n    display: block !important;\n    border-bottom: none !important;\n    opacity: 1 !important;\n  }\n  a:visited {\n    color: #fff !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  &:hover {\n    width: 110px !important;  \n  }\n"], ["\n  &:hover {\n    width: 110px !important;  \n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 14px;\n"], ["\n  padding-bottom: 14px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  text-transform: initial !important;\n"], ["\n  text-transform: initial !important;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  i {\n    margin-top: -3px;\n  }\n"], ["\n  i {\n    margin-top: -3px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 80%;\n  @media (max-width: 1023px) {\n    width: 95%;\n  }\n"], ["\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 80%;\n  @media (max-width: 1023px) {\n    width: 95%;\n  }\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var gatsby_link_1 = __webpack_require__(34);
	var googleAnalyticsService = __webpack_require__(8);
	var styled_components_1 = __webpack_require__(2);
	var PricingTablePackageFeatures = function PricingTablePackageFeatures(props) {
	    var packageFeaturesTitle = props.packageFeaturesTitle,
	        packageFeaturesSubtitle = props.packageFeaturesSubtitle,
	        packageFeatureColumnSize = props.packageFeatureColumnSize,
	        packageFeatures = props.packageFeatures;
	
	    return React.createElement(PricingTablePackageFeaturesWrapper, { className: "col-md-" + packageFeatureColumnSize + " col-sm-" + packageFeatureColumnSize + " pricing-col list-feature" }, React.createElement("div", { className: "pricing-card" }, React.createElement("div", { className: "pricing-header" }, React.createElement("h5", null, packageFeaturesTitle), React.createElement("p", { style: { fontStyle: "normal" } }, packageFeaturesSubtitle)), React.createElement("div", { className: "pricing-feature" }, packageFeatures.map(function (feature, index) {
	        if (feature.featureHasTooltip) {
	            return React.createElement("li", { key: index }, React.createElement("p", null, React.createElement("a", { className: "tooltip" }, React.createElement("span", { className: "tooltip-text" }, feature.featureName, React.createElement("span", { className: "tooltip-content" }, feature.featureDescription)))));
	        } else {
	            return React.createElement("li", { key: index }, React.createElement("p", null, feature.featureName));
	        }
	    }))));
	};
	/** STYLES => PricingTablePackageFeatures */
	var PricingTablePackageFeaturesWrapper = styled_components_1.default.div(_templateObject);
	var PricingTablePackage = function PricingTablePackage(props) {
	    var packageFeatureColumnSize = props.packageFeatureColumnSize,
	        packageName = props.packageName,
	        packagePrice = props.packagePrice,
	        packagePricingInfo = props.packagePricingInfo,
	        packageFeatures = props.packageFeatures,
	        packageIsFeatured = props.packageIsFeatured,
	        packageIsCurrent = props.packageIsCurrent,
	        packageButtonHidden = props.packageButtonHidden,
	        packageButtonText = props.packageButtonText,
	        packageButtonLinkTo = props.packageButtonLinkTo,
	        packageButtonLinkOpenNewTab = props.packageButtonLinkOpenNewTab,
	        packageButtonLinkIsForScrolling = props.packageButtonLinkIsForScrolling,
	        onPackageSelect = props.onPackageSelect;
	
	    return React.createElement("div", { className: packageIsCurrent ? "col-md-" + packageFeatureColumnSize + " col-sm-" + packageFeatureColumnSize + " pricing-col current" : "col-md-" + packageFeatureColumnSize + " col-sm-" + packageFeatureColumnSize + " pricing-col" }, React.createElement("div", { className: "pricing-card" }, React.createElement("div", { className: "pricing-header" }, React.createElement(PricingTablePackageNameWrapper, null, packageName), packageIsFeatured && React.createElement(PricingTableFeaturedRibbonWrapper, { className: "ribbon" }, React.createElement("i", { className: "fa fa-star" }), React.createElement("span", null, "Popularny")), React.createElement("div", { className: "price-box" }, React.createElement("div", { className: "price" }, packagePrice, React.createElement("div", { className: "plan" }, packagePricingInfo), props.packagePricingNetInfoVisible && React.createElement(PricingTablePackagePriceInfoDetailsWrapper, { className: "plan" }, "NETTO")))), React.createElement("div", { className: "pricing-feature" }, packageFeatures.map(function (feature, index) {
	        if (feature.featureType == "icon") {
	            return React.createElement("li", { key: index }, React.createElement("p", null, React.createElement("i", { className: feature.featureIncluded ? "fa fa-check available" : "fa fa-times available" })));
	        } else {
	            return React.createElement("li", { key: index }, React.createElement("p", null, React.createElement(FeatureTextWrapper, null, feature.featureText)));
	        }
	    })), !packageButtonHidden && !packageButtonLinkIsForScrolling && React.createElement(PricingTablePackageFooterWrapper, { className: "pricing-footer" }, React.createElement(gatsby_link_1.default, { to: packageButtonLinkTo, className: "btn btn-act rounded btn-line", onClick: onPackageSelect }, React.createElement("span", null, packageButtonText), React.createElement("i", { className: "fa fa-arrow-right" }))), !packageButtonHidden && packageButtonLinkIsForScrolling && React.createElement(PricingTablePackageFooterWrapper, { className: "pricing-footer" }, React.createElement("a", { href: packageButtonLinkTo, target: packageButtonLinkOpenNewTab ? '_blank' : '_self', className: "btn btn-act rounded btn-line", onClick: onPackageSelect }, React.createElement("span", null, packageButtonText), React.createElement("i", { className: "fa fa-arrow-right" })))));
	};
	/** STYLES => PricingTablePackage */
	var PricingTablePackageNameWrapper = styled_components_1.default.h5(_templateObject2);
	var PricingTableFeaturedRibbonWrapper = styled_components_1.default.a(_templateObject3);
	var PricingTablePackagePriceInfoDetailsWrapper = styled_components_1.default.div(_templateObject4);
	var FeatureTextWrapper = styled_components_1.default.span(_templateObject5);
	var PricingTablePackageFooterWrapper = styled_components_1.default.div(_templateObject6);
	
	var PricingTableBlock = function (_React$Component) {
	    _inherits(PricingTableBlock, _React$Component);
	
	    function PricingTableBlock(props) {
	        _classCallCheck(this, PricingTableBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onButtonClick = _this.onButtonClick.bind(_this);
	        return _this;
	    }
	
	    PricingTableBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    PricingTableBlock.prototype.onButtonClick = function onButtonClick() {
	        if (this.props.buttonClickEventType) {
	            googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
	        }
	    };
	
	    PricingTableBlock.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            packagesInfo = _props.packagesInfo,
	            packages = _props.packages;
	
	        return React.createElement("div", { className: "matraz-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(PricingTableBlockWrapper, { className: "pricing-wrapper comparison-table clearfix color-pallet-blue style-2" }, React.createElement(PricingTablePackageFeatures, _extends({}, packagesInfo)), packages.map(function (packageData, index) {
	            return React.createElement(PricingTablePackage, _extends({ key: index }, packageData, { onPackageSelect: _this2.onButtonClick }));
	        })));
	    };
	
	    return PricingTableBlock;
	}(React.Component);
	/** STYLES => PricingTableBlock */
	
	
	var PricingTableBlockWrapper = styled_components_1.default.div(_templateObject7);
	exports.default = PricingTableBlock;

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(19);
	var hero_text_on_left_block_1 = __webpack_require__(107);
	var title_block_1 = __webpack_require__(38);
	var intro_step_select_block_1 = __webpack_require__(79);
	var pricing_table_block_1 = __webpack_require__(147);
	var contact_form_block_1 = __webpack_require__(106);
	var faq_block_1 = __webpack_require__(45);
	var types_1 = __webpack_require__(15);
	var google_analytics_1 = __webpack_require__(27);
	var staticImages = __webpack_require__(33);
	var initialFormData = __webpack_require__(104);
	var freshworksData = __webpack_require__(105);
	var faqQuestionsData = __webpack_require__(43);
	var helmetData = __webpack_require__(16);
	var cacheBustingService = __webpack_require__(23);
	var achievements_counter_block_1 = __webpack_require__(76);
	var companyData = __webpack_require__(37);
	
	var ZakladanieSpolekZooPage = function (_React$Component) {
	    _inherits(ZakladanieSpolekZooPage, _React$Component);
	
	    function ZakladanieSpolekZooPage() {
	        _classCallCheck(this, ZakladanieSpolekZooPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ZakladanieSpolekZooPage.prototype.componentDidMount = function componentDidMount() {
	        cacheBustingService.handleCacheBusting(caches);
	    };
	
	    ZakladanieSpolekZooPage.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement(react_helmet_1.Helmet, _extends({}, helmetData.prepareHelmetData(types_1.PageType.ZakladanieSpolekZooPage))), React.createElement(hero_text_on_left_block_1.default, { title: "Zakładanie spółek online", description: ["Rejestrujemy spółki w całej Polsce."], backgroundImage: staticImages.BUSINESS_HANDSHAKE_BACKGROUND_IMAGE, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedMainTitleBlock }), React.createElement(title_block_1.default, { firstLineBlackStart: "Załóż spółkę w", firstLineBlue: "3 krokach", firstLineBlackEnd: "", secondLineText: "Zakładasz działalność i szukasz prostego sposobu na rejestrację spółki online? Z nami zrobisz to w 100% zdalnie bez zbędnych i niepotrzebnych formalności. Oferujemy zarówno kompleksową usługę rejestracji, jak i praktyczne materiały krok po kroku, które pozwolą Ci przeprowadzić proces samodzielnie.", paddingBottom: 0 }), React.createElement(intro_step_select_block_1.default, { stepSelectElements: [{
	                elementSelectorTitle: "WYBÓR SPÓŁKI",
	                elementSelectorDescription: ["Przedsiębiorcy najczęściej wybierają spółkę z o.o., ale dostępna jest jeszcze prosta spółka akcyjna. Podpowiemy, czym różnią się formy prowadzenia działalności i która najlepiej odpowiada Twoim potrzebom dzięki czemu podejmiesz świadomą decyzję."]
	            }, {
	                elementSelectorTitle: "KONTAKT",
	                elementSelectorDescription: "Masz już pomysł, jaką spółkę chcesz założyć, albo nadal się wahasz? Po prostu skontaktuj się, odpowiemy na pytania, rozwiejemy wątpliwości i pomożemy przejść przez formalności bez stresu. Jesteśmy dostępni przez czat, telefon oraz formularz kontaktowy."
	            }, {
	                elementSelectorTitle: "REJESTRACJA SPÓŁKI",
	                elementSelectorDescription: "To już ostatni krok. Jeżeli zdecydowałeś się na naszą pomoc, przygotowujemy wszystkie wymagane dokumenty – umowę spółki, załączniki oraz wniosek do KRS. W zależności od wybranej ścieżki podpisujesz umowę elektronicznie przez system S24 albo u notariusza. Gdy tylko spółka zostanie wpisana do KRS, można zacząć działać."
	            }], componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedStepSelectBlock, elementSelectEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooPageClickedStepSelectElement }), React.createElement(title_block_1.default, { firstLineBlackStart: "Rejestrujemy ", firstLineBlue: "Spółki", firstLineBlackEnd: "w całej Polsce", secondLineText: "Pomagamy zakładać spółki na terenie całej Polski – bez stresu, bez kolejek i bez zbędnego papieru. Działamy od lat i dobrze znamy realia sądowe czy urzędowe. Jeżeli natomiast chcesz założyć spółkę osobiście, to nasz poradnik to konkret – stworzony przez praktyków, którzy wiedzą, jak zarejestrować spółkę szybko." }), React.createElement(achievements_counter_block_1.default, { counters: [{
	                iconString: "watch",
	                counterStart: 0,
	                counterEnd: companyData.FAKTUROMANIA_YEARS_ON_MARET,
	                counterDuration: 3,
	                counterText: "LAT NA RYNKU"
	            }, {
	                iconString: "person",
	                counterStart: 0,
	                counterEnd: 600,
	                counterDuration: 5,
	                counterText: "ZAREJESTROWANYCH PRZEZ NAS SPÓŁEK"
	            }, {
	                iconString: "description",
	                counterStart: 0,
	                counterEnd: 14000,
	                counterDuration: 5,
	                counterText: "POBRAŃ PORADNIKA REJESTRACJI"
	            }], componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageViewedAchievementsBlock }), React.createElement(title_block_1.default, { firstLineBlackStart: "Przejrzyste zasady", firstLineBlue: "rejestracji spółki", firstLineBlackEnd: "", secondLineText: "Bez względu na to, czy zdecydujesz się na usługę płatną, czy wybierzesz samodzielne działanie z naszym poradnikiem – proces rejestracji spółki będzie dla Ciebie jasny, bezpieczny i uporządkowany. W ramach usługi płatnej oferujemy indywidualne wsparcie i opiekę specjalisty. Jeśli działasz samodzielnie, otrzymasz od nas przejrzysty poradnik, który krok po kroku przeprowadzi Cię przez cały proces.", paddingTop: 20 }), React.createElement(pricing_table_block_1.default, { packagesInfo: {
	                packageFeaturesTitle: "ZAŁÓŻ SPÓŁKĘ",
	                packageFeaturesSubtitle: "z o.o. lub p.s.a.",
	                packageFeatureColumnSize: 3,
	                packageFeatures: [{
	                    featureName: "Forma działalności",
	                    featureHasTooltip: true,
	                    featureDescription: "Forma prawna rejestrowanej działalności gospodarczej."
	                }, {
	                    featureName: "Przygotowanie dokumentów",
	                    featureHasTooltip: true,
	                    featureDescription: "Przygotowanie umowy spółki wraz z załącznikami m.in. oświadczenia oraz listy."
	                }, {
	                    featureName: "Wsparcie merytoryczne",
	                    featureHasTooltip: true,
	                    featureDescription: "Kontakt telefoniczny, przez czat lub mailowy z ekspertem specjalizującym się w spółkach oraz podatkach."
	                }, {
	                    featureName: "Przygotowanie wniosku KRS",
	                    featureHasTooltip: true,
	                    featureDescription: "Obejmuje przygotowanie składanego do Sądu wniosku wraz z kompletem załączników."
	                }, {
	                    featureName: "Formularze skarbowe",
	                    featureHasTooltip: true,
	                    featureDescription: "Przygotowanie formularzy skarbowych wraz z wyliczeniem zobowiązania podatkowego tj. PCC-3, NIP-8 oraz VAT-R."
	                }, {
	                    featureName: "Czas rejestracji",
	                    featureHasTooltip: true,
	                    featureDescription: "Czyli czas potrzebny do przeprocesowania wniosku przez Sąd. Czas ten jest zależny od regionu Polski, w przypadku województwa mazowieckiego, pomorskiego oraz małopolskiego czas jest najdłuższy i może przekraczać nawet 2 tygodnie."
	                }, {
	                    featureName: "Koszty urzędowe",
	                    featureHasTooltip: true,
	                    featureDescription: "Są to koszty skarbowe lub podatku PCC od kapitału zakładowego, które nie są wliczone w cenę usługi."
	                }, {
	                    featureName: "Koszty dodatkowe",
	                    featureHasTooltip: true,
	                    featureDescription: "Są to koszty dodatkowe, które nie są wliczone w cenę usługi. W przypadku rejestracji S24 jest to opłata sądowa w kwocie 350,39zł. W przypadku rejestracji tradycyjnej koszty opłat sądowych wynoszą 600zł zaś notarialne są zależne od regionu Polski, najczęściej mieszczą się w widełkach od 400 do 800zł."
	                }, {
	                    featureName: "Opieka specjalisty",
	                    featureHasTooltip: true,
	                    featureDescription: "Proces rejestracji, przygotowania umowy spółki i wszystkich dokumentów przebiega pod opieką specjalisty albo Radcy Prawnego lub Adwokata."
	                }]
	            }, packages: [{
	                packageFeatureColumnSize: 3,
	                packageName: "Rejestracja z poradnikiem",
	                packagePrice: '0',
	                packagePricingInfo: "ZŁ",
	                packagePricingNetInfoVisible: true,
	                packageIsFeatured: false,
	                packageIsCurrent: false,
	                packageFeatures: [{
	                    featureType: "text",
	                    featureText: "z o.o.",
	                    featureIncluded: true
	                }, {
	                    featureType: "text",
	                    featureText: "we własnym zakresie"
	                }, {
	                    featureType: "text",
	                    featureText: "w formie poradnika"
	                }, {
	                    featureType: "text",
	                    featureText: "we własnym zakresie"
	                }, {
	                    featureType: "text",
	                    featureText: "we własnym zakresie"
	                }, {
	                    featureType: "text",
	                    featureText: "od 48h do 2 tygodni*"
	                }, {
	                    featureType: "text",
	                    featureText: "od 23 zł"
	                }, {
	                    featureType: "text",
	                    featureText: "350,39 zł"
	                }, {
	                    featureType: "text",
	                    featureText: "we własnym zakresie"
	                }],
	                packageButtonHidden: false,
	                packageButtonText: "Wybieram",
	                packageButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000516839-rejestracja-sp%C3%B3%C5%82ki-z-o-o-krok-po-kroku-kompletny-przewodnik",
	                packageButtonLinkOpenNewTab: true,
	                packageButtonLinkIsForScrolling: true
	            }, {
	                packageFeatureColumnSize: 3,
	                packageName: "Rejestracja Fakturomania S24",
	                packagePrice: '970',
	                packagePricingInfo: "ZŁ",
	                packagePricingNetInfoVisible: true,
	                packageIsFeatured: true,
	                packageIsCurrent: true,
	                packageFeatures: [{
	                    featureType: "text",
	                    featureText: "sp. z o.o. lub p.s.a."
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "text",
	                    featureText: "od 48h do 2 tygodni*"
	                }, {
	                    featureType: "text",
	                    featureText: "od 23 zł"
	                }, {
	                    featureType: "text",
	                    featureText: "350,39 zł"
	                }, {
	                    featureType: "text",
	                    featureText: "wsparcie Eksperta"
	                }],
	                packageButtonHidden: false,
	                packageButtonText: "Wybieram",
	                packageButtonLinkTo: "#zakladanie-spolek-zoo",
	                packageButtonLinkIsForScrolling: true
	            }, {
	                packageFeatureColumnSize: 3,
	                packageName: "Rejestracja kancelaria",
	                packagePrice: '*',
	                packagePricingInfo: "Indywidualna wycena umowy spółki",
	                packageIsFeatured: false,
	                packageIsCurrent: false,
	                packageFeatures: [{
	                    featureType: "text",
	                    featureText: "każda forma działalności"
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "icon",
	                    featureIncluded: true
	                }, {
	                    featureType: "text",
	                    featureText: "od 48h do 2 tygodni*"
	                }, {
	                    featureType: "text",
	                    featureText: "od 40 zł"
	                }, {
	                    featureType: "text",
	                    featureText: "od 1000 zł*"
	                }, {
	                    featureType: "text",
	                    featureText: "Adwokat lub Radca Prawny"
	                }],
	                packageButtonHidden: false,
	                packageButtonText: "Wybieram",
	                packageButtonLinkTo: "#zakladanie-spolek-zoo",
	                packageButtonLinkIsForScrolling: true
	            }], componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.BiuroRachunkowePageViewedPricingTableBlock, buttonClickEventType: google_analytics_1.GoogleAnalyticsEventType.BiuroRachunkowePageClickedCTAButtonAtPricingTableBlock }), React.createElement(title_block_1.default, { firstLineBlackStart: "Zakładanie spółki -", firstLineBlue: "pytania i konkretne odpowiedzi", firstLineBlackEnd: "", secondLineText: "Masz pytania o założenie spółki z o.o. albo prostej spółki akcyjnej? Kapitał zakładowy, kapitał akcyjny, wspólnicy, akcjonariusze, formularze albo księgowość? Znajdziesz tu odpowiedzi na najważniejsze pytania związane z rejestracją spółki z o.o. lub p.s.a. przez internet - od kosztów, przez formalności, do wpisu w KRS. Przejrzyście, konkretnie i bez prawniczego żargonu.", paddingTop: 100 }), React.createElement(faq_block_1.default, { faqQuestions: faqQuestionsData.ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooViewedFaqBlock, faqQuestionReadEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooReadFaqQuestion }), React.createElement(title_block_1.default, { id: "zakladanie-spolek-zoo", firstLineBlackStart: "Potrzebujesz pomocy przy", firstLineBlue: "zakładaniu spółki", firstLineBlackEnd: "?", secondLineText: "Porozmawiaj z nami o rejestracji. Wiemy wszystko o spółkach z ograniczoną odpowiedzialnością, prostych spółkach akcyjnych, formalnościach lub księgowości. Doradzimy, podpowiemy i przeprowadzimy Cię przez każdy etap – od pomysłu po wpis w KRS.", paddingTop: 75, paddingBottom: 0 }), React.createElement(contact_form_block_1.default, { formInfo: initialFormData.ZakladanieSpolekZooPageFormInfo, iframeSourceUrl: freshworksData.ZAKLADANIE_SPOLEK_PAGE_FORM_IFRAME_SOURCE_URL }));
	    };
	
	    return ZakladanieSpolekZooPage;
	}(React.Component);
	
	exports.default = ZakladanieSpolekZooPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-zakladanie-spolek-zoo-tsx-487e4dc36e05a47adbdd.js